import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { SidebarClinicData, SidebarDataPermissions } from "./SidebarData";

import logo from "../../assets/transparencia 2.png";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { logout } from "../../actions/auth";

const ProfileTypes = {
  ADM: "Administrador",
  CLI: "Clinica",
  MOD: "Moderador",
};

const Sidebar = () => {
  const dispatch = useDispatch();
  const [sidebar, setSidebar] = useState(true);
  const { user } = useSelector((state) => state.auth);
  const [sidebarData, setSidebarData] = useState(SidebarClinicData);
  const [isFinanzasOpen, setIsFinanzasOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
  };
  const toggleFinanzas = () => {
    setIsFinanzasOpen(!isFinanzasOpen);
  };
  const showSidebar = () => {
    setIsFinanzasOpen(false);
    setSidebar(!sidebar);
  } 
  useEffect(() => {
    const userSidebar = user
      ? SidebarDataPermissions[user.profile_type]
      : SidebarClinicData;
    setSidebarData(userSidebar);
  }, [user]);
  return (
    <div className="sidebar">
      <div className={sidebar ? "side-menu active" : "side-menu"}>
        <div className="group-lists">
          <ul className="nav-group" onClick={showSidebar}>
            <div className="d-flex justify-content-center logo-container">
              <img src={logo} className="rounded-circle logo-img" />
            </div>
            <li className="nav-text sidebar-toggle">
              <Link className="justify-content-center">
                <i
                  className={
                    sidebar
                      ? "bi bi-arrow-right-circle"
                      : "bi bi-arrow-left-circle"
                  }
                />
                <span className="p-1">{sidebar ? "Abrir" : "Colapsar"}</span>
              </Link>
            </li>
          </ul>
          {sidebarData?.map((group, g_idx) => {
            return (
              <Fragment key={g_idx}>
                <ul className={group.cName}>
                  <div className="group-title">
                    <strong>{group.title}</strong>
                  </div>
                  {group.navList.map((item, i_idx) => {
                    return (
                      <li key={i_idx} className={item.cName}>
                        <Link
                          to={item.path}
                          onClick={() =>
                            item.subNavList && toggleFinanzas(i_idx)
                          }
                        >
                          {item.icon}
                          <span>{item.title}</span>
                        </Link>
                        {item.title === "Finanzas" &&
                          isFinanzasOpen &&
                          item.subNavList && (
                            <div className="popup-menu">
                              <ul>
                                {item.subNavList.map((subItem, i_sub) => (
                                  <li key={i_sub} className={subItem.cName}>
                                    <Link
                                      to={subItem.path}
                                      onClick={() => toggleFinanzas(i_idx)}
                                    >
                                      {subItem.title}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                      </li>
                    );
                  })}
                </ul>
                <hr />
              </Fragment>
            );
          })}
          <div className="sidebar-profile">
            <div className="profile-info">
              <Link to={`/perfil/miperfil`}>
                <div className="profile-img">
                  {user ? (
                    <h2>
                      {user.name[0]}
                      {user.first_lastname[0]}
                    </h2>
                  ) : (
                    <img src={logo} alt="user" className="rounded-circle" />
                  )}
                </div>
              </Link>
              <div className="profile-main">
                <div className="profile-name">
                  <strong>{user?.name}</strong>
                </div>
                <div className="profile-type">
                  {ProfileTypes[user ? user.profile_type : "CLI"]}
                </div>
              </div>
            </div>

            <Button className="profile-logout" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
